import { render } from "./QuestionForm.vue?vue&type=template&id=b5958768&scoped=true"
import script from "./QuestionForm.vue?vue&type=script&lang=js"
export * from "./QuestionForm.vue?vue&type=script&lang=js"

import "./QuestionForm.vue?vue&type=style&index=0&id=b5958768&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5958768"]])

export default __exports__